module.exports = __webpack_public_path__ + "static/playfairdisplay-bolditalic-72181ce3a0be4d3c10e5debc0db564d5.woff";